// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__210x6","col":"styles_col__3NsKL","actions":"styles_actions__2mB-c","conflict":"styles_conflict__1xenP"};